import {isFunction} from 'underscore';
import {Renderable, RenderableFunction} from '../../core';
import {ElementStatus, FormElementContextState, useFormElementContext} from '../../form';
import {join} from '../../utils';

import styles from './hint.module.less';

interface Props<T> {
	className?: string;
	hidden?: ((control: FormElementContextState<T>) => boolean) | boolean;
	children?: Renderable | RenderableFunction<FormElementContextState<T>>;
}

export function Hint<T = any>(props: Props<T>): JSX.Element {
	const context = useFormElementContext({}, Hint);
	const isHidden = isFunction(props.hidden) ? props.hidden(context) : props.hidden;
	const children = isFunction(props.children) ? props.children(context) : props.children;

	return <div className={join(styles.hint, props.className, isHidden && 'hidden', context.status === ElementStatus.invalid && styles.errorHint)}>{children}</div>;
}
